import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t, Trans } from '@lingui/macro';
import { Button, Dialog, DialogProps, Group } from '@economic/taco';

import Artboard from './Artboard.png';
import ExternalLink from '../../../../shared/components/ExternalLink';

interface Props {
    readMoreLink: string | undefined;
    modalProps: Partial<DialogProps>;
}

export default function SubscriptionChangeSuccessDialog({ modalProps, readMoreLink }: Props) {
    const navigate = useNavigate();

    return (
        <Dialog {...modalProps} showCloseButton={false} size="xs" defaultOpen>
            <Dialog.Content aria-label={t`Your subscription has changed`}>
                <Dialog.Title>
                    <Trans>Your subscription has changed</Trans>
                </Dialog.Title>
                <div className="flex justify-center items-center pb-16 pt-12">
                    <img className="w-64" src={Artboard} />
                </div>
                <div className="whitespace-pre-wrap">
                    <p>
                        <Trans>
                            Congratulations! You have now changed to another package. The changes happen immediately and billing
                            will be reflected on your next invoice.
                        </Trans>
                    </p>
                    {readMoreLink && (
                        <p>
                            <Trans>
                                To get off to a good start, you can go in-depth with your package{' '}
                                <ExternalLink href={readMoreLink}>here</ExternalLink>
                            </Trans>
                        </p>
                    )}
                </div>
                <Dialog.Footer>
                    <Group>
                        <Button
                            onClick={() => {
                                navigate('/settings/subscription/status');
                                window?.top?.location.reload();
                            }}>
                            <Trans>Close</Trans>
                        </Button>
                    </Group>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}
